import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';

const biLoggerFactory = iframeAppBiLoggerFactory(window.Wix);

export const updatePayButtonBiLoggerDefaults = (defaults: Record<any, any>) => {
  biLoggerFactory.updateDefaults(defaults);
};

export const biLoggerPayButton = biLoggerFactory.logger();
